"use client";
import { createContextAndHook } from "./utils/createContextAndHook.js";
const [TriggerAuthContext, useTriggerAuthContext, useTriggerAuthContextOptional] = createContextAndHook("TriggerAuthContext");
export { TriggerAuthContext, useTriggerAuthContext, useTriggerAuthContextOptional };
//# sourceMappingURL=contexts.js.map